import { render } from "./OrgSettingsIcon.vue?vue&type=template&id=3311c081"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__